import { render, staticRenderFns } from "./journeyList.vue?vue&type=template&id=7983b846&"
import script from "./journeyList.vue?vue&type=script&lang=js&"
export * from "./journeyList.vue?vue&type=script&lang=js&"
import style0 from "./journeyList.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports